module.exports = __webpack_public_path__ + "style/img/Group 1952.17d01777.png";